import 'react-animated-router/animate.css';

export { default } from 'react-animated-router';

export * from 'react-animated-router';
